import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {ProSkillAssureTestTemplateModel} from "~~/package/mapper/proSkillAssure/model/ProSkillAssureTestTemplateModel";
import {
  ProSkillAssureAssessmentSetInfoModel
} from "~~/package/mapper/proSkillAssure/model/ProSkillAssureAssessmentSetInfoModel";
import {TrackType} from "~~/package/mapper/track/model/TrackType";
import {AdvancedAssessmentType} from "~~/package/mapper/proSkillAssure/model/AdvancedAssessmentType";

export class ProSkillAssureTrackLevelModel extends Model {
  constructor(
      public trackType: TrackType = TrackType.SKILL,
      public trackLevelId: number = 0,
      public title: string = "",
      public description: string = "",
      public testTemplateList: ProSkillAssureTestTemplateModel[] = [],
      public assessmentSetInfoVO: ProSkillAssureAssessmentSetInfoModel = new ProSkillAssureAssessmentSetInfoModel(),
      public assessmentContentType: AdvancedAssessmentType = AdvancedAssessmentType.CORE,
      public referenceUrl: string = "",
      public referenceUrlExposureFlag: boolean = false,
      public level: number = 0,
      public matchedKeywords: string[] = []
  ) {
    super();
  }

  public static create(model: Partial<ProSkillAssureTrackLevelModel>): ProSkillAssureTrackLevelModel {
    return createModel<ProSkillAssureTrackLevelModel>(ProSkillAssureTrackLevelModel, {
      ...model,
      referenceUrl: model.referenceUrl ?? "",
      referenceUrlExposureFlag: model.referenceUrlExposureFlag ?? false,
      matchedKeywords: model.matchedKeywords ?? []
    });
  }
}
